export const QuestType = {
  스케줄확인: "scheduleCheck",
  트렌드확인: "trendCheck",
  토픽투표: "topicVote",
  팬로그좋아요: "fanlogLike",
  스케줄좋아요: "scheduleLike",
  유저팔로우: "userFollow",
  팬로그댓글: "fanlogComment",
  갤러리좋아요: "collectionLike",
  갤러리댓글: "collectionComment",
  팬로그생성: "fanlogCreate",
  토픽생성: "topicCreate",
  갤러리생성: "collectionCreate",
  광고보기: "advertise",
  투표: "poll",
  타입폼: "typeform",
  알림설정: "notification",
  친구초대: "invitation",
  응원작성: "cheering",
  오퍼월: "offerwall",
  챌린지: "challenge",
};
export const QuestRequirement = {
  SCHEDULE: "schedule",
  TREND: "trend",
  ADVERTISEMENT: "advertisement",
};
